import { withBoundaries } from '../../hoc';
import { SectionTitleWidgetComponent } from './SectionTitleWidget';
export default withBoundaries(SectionTitleWidgetComponent);